import $ from 'jquery';
import jQuery from 'jquery';
import Login_Router from '../Axios.js';
/* 
    Author     : Tomaz Dragar
    Mail       : <tomaz@dragar.net>
    Homepage   : http://www.dragar.net
*/


  /*    var simpleCropper = function (onComplete) {
        var cropper;
     var image_dimension_x = 300;
        var image_dimension_y = 300;
        var scaled_width = 0;
        var scaled_height = 0;
        var x1 = 0;
        var y1 = 0;
        var x2 = 0;
        var y2 = 0;
        var current_image = null;
        var image_filename = null;
        var aspX = 1;
        var aspY = 1;
        var file_display_area = null;
        var ias = null;
        var original_data = null;
        var jcrop_api;
        var bottom_html = "<input type='file' id='fileInput3' name='files[]'/ accept='image/*'><canvas id='myCanvas' style='display:none;'></canvas><div id='modal'></div><div id='preview'><div class='buttons' id='buttons_cropper'><div class='cancel'>cancel</div><div class='ok'>Ok</div></div></div>";
        $('body').append(bottom_html);

        //add click to element
         cropper = {
            croper : function (fn) {
            aspX = $('#profile_picture_A').width();
            aspY = $('#profile_picture_A').height();
            file_display_area = $('#profile_picture_A');
            $('#fileInput3').click();
        }
    };

        $(document).ready(function () {
            //capture selected filename
            $('#fileInput3').change(function (click) {
                imageUpload($('#preview').get(0));
                // Reset input value
                $(this).val("");
            });

            //ok listener
           $('.ok').click(function () {
                preview();
                $('#preview').delay(100).hide();
                $('#modal').hide();
               jcrop_api.destroy();
                reset();
            });

            //cancel listener
            $('.cancel').click(function (event) {
                $('#preview').delay(100).hide();
                $('#modal').hide();
                jcrop_api.destroy();
                reset();
            });
        });

        function reset() {
            scaled_width = 0;
            scaled_height = 0;
            x1 = 0;
            y1 = 0;
            x2 = 0;
            y2 = 0;
            current_image = null;
            image_filename = null;
            original_data = null;
            aspX = 1;
            aspY = 1;
            file_display_area = null;

        }

        function imageUpload(dropbox) {
            //Bugs knowing that there is double; fileinput3,,,supposes ly it should just be 1
            var file = $("#fileInput3").get(0).files[0];
               var imageType = /image.;

            if (file.type.match(imageType)) {
                var reader = new FileReader();
                image_filename = file.name;

                reader.onload = function (e) {
                    // Clear the current image.
                    $('#photo').remove();

                    original_data = reader.result;

                    // Create a new image with image crop functionality
                    current_image = new Image();
                    current_image.src = reader.result;
                    current_image.id = "photo";
                    current_image.style['maxWidth'] = image_dimension_x + 'px';
                    current_image.style['maxHeight'] = image_dimension_y + 'px';
                    current_image.onload = function () {
                        // Calculate scaled image dimensions
                        if (current_image.width > image_dimension_x || current_image.height > image_dimension_y) {
                            if (current_image.width > current_image.height) {
                                scaled_width = image_dimension_x;
                                scaled_height = image_dimension_x * current_image.height / current_image.width;
                            }
                            if (current_image.width < current_image.height) {
                                scaled_height = image_dimension_y;
                                scaled_width = image_dimension_y * current_image.width / current_image.height;
                            }
                            if (current_image.width == current_image.height) {
                                scaled_width = image_dimension_x;
                                scaled_height = image_dimension_y;
                            }
                        }
                        else {
                            scaled_width = current_image.width;
                            scaled_height = current_image.height;
                        }

                        // set the image size to the scaled proportions which is required for at least IE11
                        current_image.style['width'] = scaled_width + 'px';
                        current_image.style['height'] = scaled_height + 'px';

                        // Position the modal div to the center of the screen
                        $('#modal').css('display', 'block');
                        var window_width = $(window).width() / 2 - scaled_width / 2 + "px";
                        var window_height = $(window).height() / 2 - scaled_height / 2 + "px";
                        console.log("window width");
                        console.log($(window).width());
                        console.log(scaled_height);
                        // Show image in modal view
                        var buttons_position = parseInt(window_height.slice(0,-2)) + parseInt(scaled_height) + 30 + "px";
                        $("#preview").css("top", window_height);
                        $("#preview").css("left", window_width);
                        console.log(buttons_position);
                        $("#buttons_cropper").css("top", buttons_position);
                        $('#preview').show(500);



                        // Calculate selection rect
                        var selection_width = 0;
                        var selection_height = 0;

                        var max_x = Math.floor(scaled_height * aspX / aspY);
                        var max_y = Math.floor(scaled_width * aspY / aspX);


                        if (max_x > scaled_width) {
                            selection_width = scaled_width-300;
                            selection_height = max_y-200;
                        }
                        else {
                            selection_width = max_x - 300;
                            selection_height = scaled_height - 200;
                        }

                        ias = $(this).Jcrop({
                            onSelect: showCoords,
                            onChange: showCoords,
                            bgColor: '#747474',
                            bgOpacity: .4,
                            aspectRatio: aspX / aspY,
                            setSelect: [0, 0, selection_width, selection_height]
                        }, function () {
                            jcrop_api = this;
                        });
                    }

                    // Add image to dropbox element
                    dropbox.appendChild(current_image);
                }

                reader.readAsDataURL(file);
            } else {
                dropbox.innerHTML = "File not supported!";
            }
        }

        function showCoords(c) {
            x1 = c.x;
            y1 = c.y;
            x2 = c.x2;
            y2 = c.y2;
        }

        function preview() {
            // Set canvas
            var canvas = document.getElementById('myCanvas');
            var context = canvas.getContext('2d');

            // Delete previous image on canvas
            context.clearRect(0, 0, canvas.width, canvas.height);

            // Set selection width and height
            var sw = x2 - x1;
            var sh = y2 - y1;


            // Set image original width and height
            var imgWidth = current_image.naturalWidth;
            var imgHeight = current_image.naturalHeight;

            // Set selection koeficient
            var kw = imgWidth / $("#preview").width();
            var kh = imgHeight / $("#preview").height();

            // Set canvas width and height and draw selection on it
            canvas.width = aspX;
            canvas.height = aspY;
            context.drawImage(current_image, (x1 * kw), (y1 * kh), (sw * kw), (sh * kh), 0, 0, aspX, aspY);

            // Convert canvas image to normal img
            var dataUrl = canvas.toDataURL();
            var imageFoo = document.createElement('img');
            imageFoo.src = dataUrl;

            // Append it to the body element
            $('#preview').delay(100).hide();
            $('#modal').hide();
            //file_display_area.html('');
            document.getElementById("profile_picture_A").src =  imageFoo.src;
            var i = sessionStorage.getItem("i_name");
            url_to_image(dataUrl,i.concat("_front"));
     
          //  document.getElementById("profile_picture").backgroundImage = "url("+imageFoo+");"
            //document.getElementById("profile_picture").backgroundImage = "url('img_tree.png')";
            //document.getElementById("profile_picture").append(imageFoo);
            if (onComplete) onComplete(
                {                    
                    "original": { "filename": image_filename, "base64": original_data, "width": current_image.width, "height": current_image.height },
                    "crop": { "x": (x1 * kw), "y": (y1 * kh), "width": (sw * kw), "height": (sh * kh) }
                }
               );
        }

        $(window).resize(function () {
            // Position the modal div to the center of the screen
            var window_width = $(window).width() / 2 - scaled_width / 2 + "px";
            var window_height = $(window).height() / 2 - scaled_height / 2 + "px";

            // Show image in modal view
            $("#preview").css("top", window_height);
            $("#preview").css("left", window_width);
        });
 return {
            cropper   : function () { cropper.croper(); return this; },
        };

    };
*/


/* 
    Author     : Tomaz Dragar
    Mail       : <tomaz@dragar.net>
    Homepage   : http://www.dragar.net
*/

(function ($) {

    $.fn.delete_input = function() { 
       // alert('You have successfully defined your function!'); 
       document.getElementById("cropper_holder").innerHTML = "";
    };

    $.fn.simpleCropper = function (onComplete) {

        var image_dimension_x = 350;
        var image_dimension_y = 350;
        var scaled_width = 0;
        var scaled_height = 0;
        var x1 = 0;
        var y1 = 0;
        var x2 = 0;
        var y2 = 0;
        var current_image = null;
        var image_filename = null;
        var aspX = 1;
        var aspY = 1;
        var file_display_area = null;
        var ias = null;
        var original_data = null;
        var jcrop_api;
        var bottom_html = "<input type='file' id='fileInput' name='files[]'/ accept='image/*'><canvas id='myCanvas' style='display:none;'></canvas><div id='modal'></div><div id='preview'><div class='buttons'><div class='cancel'></div><div class='ok'></div></div></div>";
        var id_item;
        $.fn.delete_input();
        $('#cropper_holder').append(bottom_html);

        //add click to element
        this.click(function () {
            //console.log();
            //  console.log("apa lah");
            //taking normal picture usual height and width
            var height = "";
            var width = "";
               console.log($(this));
            console.log($(this).prev().width());
                  console.log($(this).prev().height());
            aspX = $(this).prev().width();
            aspY = $(this).prev().height();
            file_display_area = $(this).prev();
            //console.log("apani");
            id_item = $(this).attr("id");

            $('#fileInput').click();
        });

        $(document).ready(function () {
            //capture selected filename
            $('#fileInput').change(function (click) {
                imageUpload($('#preview').get(0));
                // Reset input value
                $(this).val("");
            });

            //ok listener
            $('.ok').click(function () {
                preview();
                $('#preview').delay(100).hide();
                $('#modal').hide();
                jcrop_api.destroy();
                reset();
            });

            //cancel listener
            $('.cancel').click(function (event) {
                $('#preview').delay(100).hide();
                $('#modal').hide();
                jcrop_api.destroy();
                reset();
            });
        });

        function reset() {
            scaled_width = 0;
            scaled_height = 0;
            x1 = 0;
            y1 = 0;
            x2 = 0;
            y2 = 0;
            current_image = null;
            image_filename = null;
            original_data = null;
            aspX = 1;
            aspY = 1;
            file_display_area = null;
        }

        function imageUpload(dropbox) {
            var file = $("#fileInput").get(0).files[0];

            var imageType = /image.*/;

            if (file.type.match(imageType)) {
                var reader = new FileReader();
                image_filename = file.name;

                reader.onload = function (e) {
                    // Clear the current image.
                    $('#photo').remove();

                    original_data = reader.result;

                    // Create a new image with image crop functionality
                    current_image = new Image();
                    current_image.src = reader.result;
                    current_image.id = "photo";
                    current_image.style['maxWidth'] = image_dimension_x + 'px';
                    current_image.style['maxHeight'] = image_dimension_y + 'px';
                    current_image.onload = function () {
                        // Calculate scaled image dimensions
                        if (current_image.width > image_dimension_x || current_image.height > image_dimension_y) {
                            if (current_image.width > current_image.height) {
                                scaled_width = image_dimension_x;
                                scaled_height = image_dimension_x * current_image.height / current_image.width;
                            }
                            if (current_image.width < current_image.height) {
                                scaled_height = image_dimension_y;
                                scaled_width = image_dimension_y * current_image.width / current_image.height;
                            }
                            if (current_image.width == current_image.height) {
                                scaled_width = image_dimension_x;
                                scaled_height = image_dimension_y;
                            }
                        }
                        else {
                            scaled_width = current_image.width;
                            scaled_height = current_image.height;
                        }

                        // set the image size to the scaled proportions which is required for at least IE11
                        current_image.style['width'] = scaled_width + 'px';
                        current_image.style['height'] = scaled_height + 'px';

                        // Position the modal div to the center of the screen
                        $('#modal').css('display', 'block');
                        var window_width = $(window).width() / 2 - scaled_width / 2 + "px";
                        var window_height = $(window).height() / 2 - scaled_height / 2 + "px";

                        // Show image in modal view
                        $("#preview").css("top", window_height);
                        $("#preview").css("left", window_width);
                        $('#preview').show(500);


                        // Calculate selection rect
                        var selection_width = 0;
                        var selection_height = 0;

                        var max_x = Math.floor(scaled_height * aspX / aspY);
                        var max_y = Math.floor(scaled_width * aspY / aspX);


                        if (max_x > scaled_width) {
                            selection_width = scaled_width;
                            selection_height = max_y;
                        }
                        else {
                            selection_width = max_x;
                            selection_height = scaled_height;
                        }

                        ias = $(this).Jcrop({
                            onSelect: showCoords,
                            onChange: showCoords,
                            bgColor: '#747474',
                            bgOpacity: .4,
                            aspectRatio: aspX / aspY,
                            setSelect: [0, 0, selection_width, selection_height]
                        }, function () {
                            jcrop_api = this;
                        });
                    }

                    // Add image to dropbox element
                    dropbox.appendChild(current_image);
                }

                reader.readAsDataURL(file);
            } else {
                dropbox.innerHTML = "File not supported!";
            }
        }

        function showCoords(c) {
            x1 = c.x;
            y1 = c.y;
            x2 = c.x2;
            y2 = c.y2;
        }

        function preview() {
            // Set canvas
            var canvas = document.getElementById('myCanvas');
            var context = canvas.getContext('2d');

            // Delete previous image on canvas
            context.clearRect(0, 0, canvas.width, canvas.height);

            // Set selection width and height
            var sw = x2 - x1;
            var sh = y2 - y1;


            // Set image original width and height
            var imgWidth = current_image.naturalWidth;
            var imgHeight = current_image.naturalHeight;

            // Set selection koeficient
            var kw = imgWidth / $("#preview").width();
            var kh = imgHeight / $("#preview").height();

            // Set canvas width and height and draw selection on it
            canvas.width = aspX;
            canvas.height = aspY;
            context.drawImage(current_image, (x1 * kw), (y1 * kh), (sw * kw), (sh * kh), 0, 0, aspX, aspY);

            // Convert canvas image to normal img
            var dataUrl = canvas.toDataURL("image/jpeg");
            var imageFoo = document.createElement('img');
            imageFoo.src = dataUrl;
            console.log(dataUrl);

            // Convert canvas image to data URL (JPG format)
            // Create a FormData object
    

           // document.getElementById("profile_picture_A").src =  imageFoo.src;
            var i = sessionStorage.getItem("i_name");
            setItem(i,dataUrl);
            cropper_input_differentiation(imageFoo.src,i,id_item);
            // Append it to the body element
            $('#preview').delay(100).hide();
            $('#modal').hide();
            //file_display_area.html('');
  
           // file_display_area.append(imageFoo);

            if (onComplete) onComplete(
                {                    
                    "original": { "filename": image_filename, "base64": original_data, "width": current_image.width, "height": current_image.height },
                    "crop": { "x": (x1 * kw), "y": (y1 * kh), "width": (sw * kw), "height": (sh * kh) }
                }
               );
        }

        $(window).resize(function () {
            // Position the modal div to the center of the screen
            var window_width = $(window).width() / 2 - scaled_width / 2 + "px";
            var window_height = $(window).height() / 2 - scaled_height / 2 + "px";

            // Show image in modal view
            $("#preview").css("top", window_height);
            $("#preview").css("left", window_width);
        });


    }
}(jQuery));

    
    function upload_file(uri,name) {
//         <!-- Ajax JavaScript File Upload Logic -->

  var http = new XMLHttpRequest();
  var url = './Javascript_Login/upload.php';
  var params = 'orem='+uri+"&name="+name;
  http.open('POST', url, true);

  //Send the proper header information along with the request
  http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

  http.onload = function(){
    console.log(this.responseText);
  };


  http.send(params);
/*fetch(url, {
    method: 'POST',
    body: FormData,
  }).then((response) => {
    console.log(response)
  });  */
    }
      


function url_to_image(inputURL,name) {

    //var blobObject = blobCreationFromURL(inputURL);
    
    var fdataobj = new FormData();
    var fd = new FormData()
    // Create formdata object and append the object
    // file to the name 'Blob file'
    /*fetch(inputURL)
    .then(res => res.blob())
    .then(blob => {


    fd.append('image', blob, 'filename')
  
    console.log(fd);
    upload_file(fd);   

  // Upload
  // fetch('upload', {method: 'POST', body: fd})
})

//    fdataobj.append("files", blobObject,"chris2.jpg");
  
  //  upload_file(fdataobj);   
*/

// upload_file(inputURL,name);   
}

   // Create Blob file from URL
    function blobCreationFromURL(inputURI) {

        var binaryVal;

        // mime extension extraction
        var inputMIME = inputURI.split(',')[0].split(':')[1].split(';')[0];

        // Extract remaining part of URL and convert it to binary value
        if (inputURI.split(',')[0].indexOf('base64') >= 0)
            binaryVal = atob(inputURI.split(',')[1]);

        // Decoding of base64 encoded string
        else
            binaryVal = unescape(inputURI.split(',')[1]);

        // Computation of new string in which hexadecimal
        // escape sequences are replaced by the character
        // it represents

        // Store the bytes of the string to a typed array
        var blobArray = [];
        for (var index = 0; index < binaryVal.length; index++) {
            blobArray.push(binaryVal.charCodeAt(index));
        }

        return new Blob([blobArray], {
            type: inputMIME
        });
    }

    function cropper_input_differentiation(blub,name,id,formData){
console.log("aoa la");
console.log(id);
console.log(name);

if(name != null  && name != "g_initialize" && id != "cropme_profile_picture_A_container_main_id") {
    document.getElementById("profile_picture_A").src =  blub;

//to used this data in the finishing function

   
        url_to_image(blub,name.concat("_front"));

        }

if(id == "cropme_profile_picture_A_container_main_id"){
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const group_id = urlParams.get('id');
    document.getElementById("cropme_profile_picture_A_container_main").src =  blub;
            //     Login_Router.Profile_Sending(formData); 
           url_to_image(blub,group_id.concat("_front"));
    }


if(id == "cropme_profile_picture_A_container"){
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const group_id = urlParams.get('id');
    document.getElementById("cropme_profile_picture_A_container").src =  blub;
         //        Login_Router.Profile_Sending(formData); 
           url_to_image(blub,name.concat("_front"));
    }


}

function setItem(name,formData){
    console.log("what is happening here");
sessionStorage.setItem("p_formData_background", formData);
sessionStorage.setItem("p_name", name.toString());

}  







